//TODO: Refactor out

import deeplinks from '../mock/data/deeplinks.json';

const fetch = (mockData, time = 0) => new Promise(
  resolve => setTimeout(() => {
    resolve(mockData);
  }, time),
);

export default {
  fetchDeeplinks() {
    // console.log(deeplinks);
    return fetch(deeplinks, 1000);
  }
};